import {_} from './index'

export const lodash_removePrivateFieldsCloneCustomizer = (value, key, parent) => !_.startsWith(key, '__')
export function combineArraysRecursively(array_of_arrays) {

  // First, handle some degenerate cases...

  if (!array_of_arrays) {
    // Or maybe we should toss an exception...?
    return [];
  }

  if (!Array.isArray(array_of_arrays)) {
    // Or maybe we should toss an exception...?
    return [];
  }

  if (array_of_arrays.length == 0) {
    return [];
  }

  for (let i = 0; i < array_of_arrays.length; i++) {
    if (!Array.isArray(array_of_arrays[i]) || array_of_arrays[i].length == 0) {
      // If any of the arrays in array_of_arrays are not arrays or are zero-length array, return an empty array...
      return [];
    }
  }

  // Done with degenerate cases...
  let outputs = [];

  function permute(arrayOfArrays, whichArray = 0, output = null) {

    arrayOfArrays[whichArray].forEach((array_element) => {
      if (whichArray == array_of_arrays.length - 1) {
        // Base case...
        outputs.push([output, array_element].filter(f => !(_.isNull(f)) || _.isUndefined(f)));
      } else {
        // Recursive case...
        permute(arrayOfArrays, whichArray + 1, (output ?? '') + array_element);
      }
    });/*  forEach() */
  }

  permute(array_of_arrays);

  return outputs;
}

export const lodashMergeOverwriteArraysFn = (dest, src) => _.isArray(dest) ? src : undefined


// WEBPACK FOOTER //
// ./src/shared/components/3rd-party/lodash.ts